<template lang="pug">
    Page.residentials
        .residentials__top(
            slot="header"
        )
            h1.residentials__title
                | Жилые комплексы

            .residentials__subheader
                SvInput.residentials__search(
                    v-model="search"
                    placeholder="Введите название жилого комплекса"
                    color="gray"
                    size="large"
                )

                SvButton.residentials__add(
                    view="big"
                    text="Добавить"
                    :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                    @click="transfer('new')"
                )

        SvTable.residentials__table(
            :headers="headers"
            :body="list"
            @transfer="(el) => transfer(el.id)"
        )
</template>

<script>
import {mapGetters} from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
    name: 'Residentials',

    data() {
        return {
            headers: [
                {
                    title: 'Название',
                    path: 'name',
                    width: '20%',
                },
                {
                    title: 'Застройщик',
                    path: 'developer',
                    width: '30%',
                },
                {
                    title: 'Символьный код',
                    path: 'alias',
                    width: '20%',
                },
                {
                    title: 'Дата изменения',
                    path: 'updated_at',
                    width: '15%',
                },
                {
                    title: 'Аквтивность',
                    path: 'is_active',
                    width: '15%',
                },
            ],
        };
    },

    beforeMount() {
        this.$store.dispatch('residential/getList');
    },

    components: {
        Page,
        SvInput,
        SvButton,
        SvTable,
    },

    computed: {
        ...mapGetters({
            list: 'residential/getList',
        }),

        search: {
            get() {
                return this.$store.state.residential.search;
            },

            set(search) {
                this.$store.commit('residential/setSearch', search);
            },
        },
    },

    methods: {
        transfer(id) {
            this.$router.push({
                name: 'residential-edit',
                params: {
                    id,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.residentials__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.residentials__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.residentials__search {
    width: 47%;
    min-width: 280px;
}

.residentials__table {
    margin-top: 30px;
}
</style>
